export const emptyRichTextValue = '<p><br></p>';

export const hasPostableLoungeContent = (
  message: string | null | undefined,
  image: unknown
) => {
  const trimmedMessage = typeof message === 'string' ? message.trim() : '';
  return (!!trimmedMessage && trimmedMessage !== emptyRichTextValue) || !!image;
};
